import { LOCALES } from 'i18n/locales';

export const enhancedMeasuresListIntl = {
    [LOCALES.ENGLISH]: {
        'enhancedMeasures.list.comply': 'Comply with all enhanced measures before starting works.',
        'enhancedMeasures.list.collapse': 'Collapse all',
        'enhancedMeasures.list.expand': 'Expand all',
        'enhancedMeasures.list.actor.loading': 'Asset owner loading...',
        'enhancedMeasures.list.actor.error': 'Error: Asset owner not loaded',
        'enhancedMeasures.contactDetailsError': '<strong>Error:</strong> Contact details could not be loaded. Please try reloading the contact details or contact the <serviceDesk>service desk</serviceDesk>.',
        'enhancedMeasures.contactDetailsError.group': 'Contact details could not be loaded for this group.',
        'enhancedMeasures.contactDetailsError.button': 'Retry'
    },
    [LOCALES.WELSH]: {
        'enhancedMeasures.list.comply': '[Comply with all enhanced measures before starting works.]',
        'enhancedMeasures.list.collapse': '[Collapse all]',
        'enhancedMeasures.list.expand': '[Expand all]',
        'enhancedMeasures.list.actor.loading': '[Asset owner loading...]',
        'enhancedMeasures.list.actor.error': '[Error: Asset owner not loaded]',
        'enhancedMeasures.contactDetailsError': '[<strong>Error:</strong> Contact details could not be loaded. Please try reloading the contact details or contact the <serviceDesk>service desk</serviceDesk>.]',
        'enhancedMeasures.contactDetailsError.group': '[Contact details could not be loaded for this group.]',
        'enhancedMeasures.contactDetailsError.button': '[Retry]'

    }
};
